var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"light","small":"","title":"Copiar"},on:{"click":_vm.copyData}},[_vm._v(" mdi mdi-clipboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }